<template>
	<div>
		<short-header />
		<div class="search-header theme-light">
			<div class="panel_header">
				<div id="scroll-on-page-chage" class="container">
					<h1>
						Навигатор медиа
					</h1>

					<search v-model="search" />

					<search-line-menu :links="links" />
				</div>
			</div>
		</div>
		<b-container class="mt-3" tag="main">
			<div class="panel announces mt-xs-only-0 mt-sm-only-0 mt-md-only-0">
				<div class="row mb-3">
					<div class="col-12 col-lg-3 d-md-block">
						<div class="d-lg-none border-top border-bottom text-center py-3 mb-4">
							<div
								class="btn btn-primary"
								role="button"
								@click="isFiltersActive ? isFiltersActive = false : isFiltersActive = true"
							>
								{{ isFiltersActive ? 'Свернуть фильтр' : 'Фильтр' }}
							</div>
						</div>
						<div
							id="events-filters-modal"
							class="filters-modal d-lg-block"
							:class="[isFiltersActive ? '' : 'd-none']"
						>
							<div class="filters-box">
								<div class="mb-lg-4">
									<ul class="nav flex-column" role="tablist">
										<li v-for="(item, index) in items" :key="'li-' + item.key" class="nav-item">
											<events-accordion
												:key="item.key"
												:value="getSelected(item)"
												:visible="isVisible(item, index)"
												:title="item.title"
												:options="item.options"
												@update:visible="visible[item.key] = $event"
												@input="onSelected(item, $event)"
											/>
										</li>
									</ul>
								</div>
							</div>
							<div class="filters-footer">
								<div class="mb-lg-4 d-none d-lg-block">
									<b-button
										variant="primary"
										@click="$router.push({ query: undefined }); isFiltersActive = false;"
									>
										Сбросить фильтры
									</b-button>
								</div>
								<div class="d-flex h-100 justify-content-between align-items-center d-lg-none buttons-group">
									<b-button
										variant="link"
										@click="$router.push({ query: undefined });"
									>
										Очистить
									</b-button>
									<b-button
										v-scroll-to="'#panel_useful'"
										variant="primary"
										class="mr-2 mr-lg-0"
									>
										Применить
									</b-button>
								</div>
							</div>
						</div>
					</div>

					<b-col cols="12" lg="9">
						<b-container v-if="$fetchState.pending" class="d-flex justify-content-center">
							<b-spinner
								style="width: 3em; height: 3em; margin-right: 10px;"
							/>
						</b-container>
						<b-container v-else-if="content && content.data && content.data.length === 0">
							<b-alert show class="d-flex justify-content-center mb-3">
								По вашему запросу ничего не найдено
							</b-alert>
						</b-container>
						<b-container v-else-if="$fetchState.error">
							<b-alert variant="danger" show class="d-flex justify-content-center mb-3">
								{{ $fetchState.error.message || error }}
							</b-alert>
						</b-container>
						<b-container v-else-if="content">
							<b-row>
								<div id="panel_useful" class="programms_list">
									<ul class="announce_list">
										<li v-for="item in content.data" :key="item.id" class="row">
											<div class="col-12 col-md-5 col-lg-5 order-md-1">
												<a
													v-if="!item.is_has_blocks && item.project_content_download_link"
													:href="item.project_content_download_link"
													class="announce_image_block"
												>
													<img
														v-if="item.listing_cover_small.src"
														:src="item.listing_cover_small.src"
														alt=""
													>
												</a>
												<nuxt-link
													v-else
													:to="$url.media(item.slug, item.taxonomy_type_slug, {}, item.lang)"
													class="announce_image_block"
												>
													<img
														v-if="item.listing_cover_small.src"
														:src="item.listing_cover_small.src"
														alt=""
													>
												</nuxt-link>
											</div>
											<div class="col-12 col-md-7 col-lg-7">
												<div class="row h-100">
													<div class="col-12 col-lg-12">
														<div class="announce_content_block">
															<div class="announce_content_header">
																<div class="tag_string">
																	<span>{{ contentTitleTypeMap[item.content_type] }}</span><template
																		v-if="item.authors !== null"
																	>
																		<span
																			v-for="author in item.authors"
																			:key="author.title"
																		>{{ author.title }}</span>
																	</template>
																</div>
															</div>
															<div class="announce_content_middle">
																<a
																	v-if="!item.is_has_blocks && item.project_content_download_link"
																	:href="item.project_content_download_link"
																	class="title announce_title"
																>
																	{{ item.title }}
																</a>
																<nuxt-link
																	v-else
																	:to="$url.media(item.slug, item.taxonomy_type_slug, {}, item.lang)"
																	class="title announce_title"
																>
																	{{ item.title }}
																</nuxt-link>
															</div>
															<div class="announce_content_footer">
																<a
																	v-if="!item.is_has_blocks && item.project_content_download_link"
																	:href="item.project_content_download_link"
																	class="more_link"
																>
																	{{ contentTypeMap[item.content_type] }}
																</a>
																<nuxt-link
																	v-else
																	:to="$url.media(item.slug, item.taxonomy_type_slug, {}, item.lang)"
																	class="more_link"
																>
																	{{ contentTypeMap[item.content_type] }}
																</nuxt-link>
															</div>
														</div>
													</div>
												</div>
											</div>
										</li>
									</ul>
									<b-pagination
										v-if="content.meta"
										v-model="page"
										:total-rows="content.meta && content.meta.total || 0"
										:per-page="content.meta && content.meta.per_page || 0"
										:limit="7"
										align="center"
										pills
										hide-goto-end-buttons
										next-class="pagination-next"
										prev-class="pagination-prev"
										prev-text=""
										next-text=""
									/>
								</div>
							</b-row>
						</b-container>
						<b-container v-else>
							<b-alert show class="d-flex justify-content-center mb-3">
								Нет данных
							</b-alert>
						</b-container>
					</b-col>
				</div>
			</div>
		</b-container>
		<main-footer />
	</div>
</template>

<script>
import SearchLineMenu from '@/components/layouts/_partials/SearchLineMenu.vue';
import searchMixin from '@/mixins/searchMixin';
import Search from '@/components/refactor/Search.vue';
import createJivoMixin from '~/mixins/createJivoMixin';
import EventsAccordion from '~/components/Events/EventsAccordion.vue';
import MainFooter from '~/components/layouts/footers/MainFooter.vue';
import ShortHeader from '~/components/layouts/headers/ShortHeader.vue';
import makeCanonicalLink from '~/utils/seo/makeCanonicalLink';
import links from './links';

export default {
	name: 'ContentPage',
	components: {
		ShortHeader,
		MainFooter,
		EventsAccordion,
		Search,
		SearchLineMenu,
	},
	mixins: [searchMixin, createJivoMixin(null, true)],
	async asyncData({ query }) {
		const searchValue = query.search || '';
		return { searchValue };
	},
	data() {
		return {
			content: null,
			visible: {},
			links,
			isFiltersActive: false,
			announceMore: false,
			contentTypeMap: {
				0: 'Читать',
				1: 'Смотреть',
				2: 'Слушать',
				3: 'Читать',
			},
			contentTitleTypeMap: {
				0: 'Статья',
				1: 'Видео',
				2: 'Подкаст',
				3: 'Q&A',
			},
			contentIconMap: {
				0: 'icon-text',
				1: 'icon-video',
				2: 'icon-audio',
				3: 'icon-qa',
			},
			timer: null,
		};
	},
	async fetch() {
		const { query } = this.$route;
		try {
			this.content = await this.$api.axios.$get('api/navigator/content', { params: query });
		} catch (error) {
			console.error(error);
			// non-POJOs so rethrow
			throw new Error(error.message);
		}
	},
	head() {
		// TODO: fill metadata
		return {
			title: 'Навигатор контента',
			link: [
				{
					rel: 'canonical',
					hid: 'canonical',
					href: makeCanonicalLink(this.$route.path),
				},
			],
			meta: [{
				hid: 'robots',
				name: 'robots',
				content: 'index, follow',
			}],
			script: [
				{
					src: '//code.jivosite.com/widget/lTPe1gNo2f',
					body: true,
					async: true,
					defer: true,
				},
			],
		};
	},
	computed: {
		items() {
			const items = [
				this.filters.taxonomy_types,
				this.filters.content_types,
				this.filters.taxonomy_sections,
				this.filters.taxonomy_projects,
			];
			const filteredItems = [];
			const { length } = items;
			// eslint-disable-next-line no-plusplus
			for (let i = 0; i < length; ++i) {
				if (items[i]) {
					filteredItems.push(items[i]);
				}
			}
			return filteredItems;
		},
		selectedFilters() {
			const items = {
				taxonomy_types: this.taxonomy_types,
				content_types: this.content_types,
				taxonomy_sections: this.taxonomy_sections,
				taxonomy_projects: this.taxonomy_projects,
			};
			const filteredItems = {};
			Object.keys(items).forEach((key) => {
				if (this.filters[key] && items[key].length > 0) {
					const filterArray = this.filters[key].options.filter((option) => items[key].includes(option.value));
					if (filteredItems[key] === undefined) {
						filteredItems[key] = [];
					}
					filterArray.forEach((filter) => filteredItems[key] = [...filteredItems[key], filter.text]);
				}
			});
			return filteredItems;
		},
		content_types: {
			get() {
				if (!this.$route.query.content_types) return [];
				return Array.isArray(this.$route.query.content_types)
					? this.$route.query.content_types.map(Number)
					: [Number(this.$route.query.content_types)];
			},
			set(contentTypes) {
				this.$router.push({
					query: {
						...this.$route.query,
						content_types: contentTypes || undefined,
					},
				});
			},
		},
		taxonomy_sections: {
			get() {
				if (!this.$route.query.taxonomy_sections) return [];
				return Array.isArray(this.$route.query.taxonomy_sections)
					? this.$route.query.taxonomy_sections.map(Number)
					: [Number(this.$route.query.taxonomy_sections)];
			},
			set(taxonomySections) {
				this.$router.push({
					query: {
						...this.$route.query,
						taxonomy_sections: taxonomySections || undefined,
						page: undefined,
						taxonomy_topics: undefined,
					},
				});
			},
		},
		taxonomy_projects: {
			get() {
				if (!this.$route.query.taxonomy_projects) return [];
				return Array.isArray(this.$route.query.taxonomy_projects)
					? this.$route.query.taxonomy_projects.map(Number)
					: [Number(this.$route.query.taxonomy_projects)];
			},
			set(taxonomyProjects) {
				this.$router.push({
					query: {
						...this.$route.query,
						taxonomy_projects: taxonomyProjects || undefined,
						page: undefined,
					},
				});
			},
		},
		taxonomy_types: {
			get() {
				if (!this.$route.query.taxonomy_types) return [];
				return Array.isArray(this.$route.query.taxonomy_types)
					? this.$route.query.taxonomy_types.map(Number)
					: [Number(this.$route.query.taxonomy_types)];
			},
			set(taxonomyTypes) {
				this.$router.push({
					query: {
						...this.$route.query,
						taxonomy_types: taxonomyTypes || undefined,
					},
				});
			},
		},
		page: {
			get() {
				return Number(this.$route.query.page) || 1;
			},
			set(page) {
				this.$scrollTo('#events-scroll-to');
				this.$router.push({
					query: {
						...this.$route.query,
						page: page > 1 ? page : undefined,
					},
				});
			},
		},
		search: {
			get() {
				return this.searchValue;
			},
			set(search) {
				this.searchValue = search || '';
				this.debouncedSearch(search);
			},
		},
		filters() {
			const dict = {};
			if (this.content) {
				this.content.filters.forEach((i) => {
					dict[i.key] = i;
				});
			}
			return dict;
		},
	},
	watch: {
		'$route.query': {
			handler() {
				this.onFetch();
			},
		},
		selectedFilters(filters) {
			if (filters && Object.keys(filters).length > 0) {
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					event: 'ajax_page_load',
					tags_filter_select: filters,
				});
			}
		},
	},
	methods: {
		isVisible({ key }, index) {
			if (this.visible[key] === undefined) {
				this.visible[key] = index === 0;
			}
			return this.visible[key];
		},
		getSelected({ key }) {
			if (this[key].length > 0) {
				this.visible[key] = true;
			}
			return this[key];
		},
		onSelected({ key }, value) {
			this[key] = value;
		},
		onFetch() {
			if (this.$fetchState.pending) {
				clearTimeout(this.timer);
				this.timer = setTimeout(this.onFetch, 50);
			} else {
				clearTimeout(this.timer);
				this.$fetch();
			}
		},
	},
};
</script>
<style style lang="scss" scoped>
@import "~/assets/styles/components/home/panel-programms";
@import "~/assets/styles/components/layouts/event-search-header";
@include media-breakpoint-down(md) {
	.filters-modal {
		// display: none;
		position: relative;
		top: 0;
		left: 0;
		z-index: 1001;
		width: 100vw;
		//height: 100vh;
		background: $theme-light;
		margin: 0 0 0 -0.75rem;
		// padding: 1.5rem 0 3rem;
	}
	.filters-modal .custom-switch {
		padding-top: 0.75rem;
	}
	.filters-box {
		width: 100%;
		//height: 99vh;
		//overflow-y: scroll;
	}

	.filters-footer {
		// display: flex;
		// align-items: center;
		// justify-content: space-between;
		position: relative;
		bottom: 0;
		width: 100%;
		background: $white;
		padding: 0.75rem;
		margin: 0 0 1rem 0;
	}
	.filters-footer .buttons-group {
		justify-content: flex-start!important;
		height: auto!important;
	}
	.filters-footer .buttons-group .btn-link {
		order:2;
	}
	.filters-footer .buttons-group .btn-primary {
		order:1;
	}
}
</style>

<style lang="scss">

	@import "~/assets/styles/components/home/panel-announces";

	@import "assets/styles/sk_variables";
	@import "assets/styles/bootstrap/scss/functions";
	@import "assets/styles/bootstrap/scss/variables";
	@import "assets/styles/bootstrap/scss/mixins";

	.programm {
		flex-direction: row;
		min-height: 25rem;
	}

	.tag_list {
		& li {
			& a {
				color: $white;
			}
		}
	}

	.list-inline-item {
		display: block;
	}
	.nav-custom {
		// padding-left: 2rem;
		padding: 0;
	}
	.nav-item-none {
		// margin-bottom: .5rem;
		// font-size: small;
		list-style: none;

		.custom-control-label {
			&::before {
				border: $body-color solid 1px;
			}
		}

	}

	.custom-switch {
		.custom-control-label {
			&::before {
				border: $body-color solid 1px;
			}
			&::after {
				background-color: $body-color;
			}

		}
	}

	.custom-control-input[disabled] ~ .custom-control-label,
	.custom-control-input:disabled ~ .custom-control-label {
		&::before {
			background-color: $custom-control-indicator-border-color;
			border: $custom-control-indicator-border-color solid 1px;
		}
	}

	.nav {
		background-color: $theme-light;
	}

	.nav-item {
		padding: 0.5rem 0rem 0.5rem 1rem;
		border-bottom: 1px $body-color solid;
		&:first-child {
			border-top: 1px $body-color solid;
		}

		div {
			a {
				button {
					font-size: 0.6rem;
					display: none;
				}
				&:hover{
					button {
						display: flex;
					}
				}
			}
		}

	}

	.nav-item-none {
		// line-height: 2;

		.custom-control-label {
			margin-bottom: 0.45rem;

			span {
				display: block;
				margin-top: 0.25rem;
				line-height: 1.08rem;
			}
		}

	}

	.programm.header_wrapper {
		.programm_type {
			color: $white;
		}
		.programm_content {
			z-index: 1;
		}

		@include overlay_shadow;
		background-position: center center;
		background-repeat: no-repeat;
		background-size: cover;
		color: $white;

		.programm_content_footer {
			a {
				color: $white;
			}
		}

	}
</style>
